import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
// import Drawer from '@material-ui/core/Drawer';
// import MenuItem from '@material-ui/core/MenuItem';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import classNames from 'classnames';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Button from '@material-ui/core/Button';
// import ReadMoreReact from 'read-more-react';
// import ReplyIcon from '@material-ui/icons/Reply';
import Modal from '@material-ui/core/Modal';
import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
// import InfiniteScroll from 'react-infinite-scroller';
import Header from '../../components/Header';
// import MenuDrawer from '../../components/MenuDrawer';
import SearchButton from '../../components/atoms/SearchButton';
// import CsvDownloadButton from '../../components/atoms/CsvDownloadButton';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import { isAuthenticated, sendLogin } from '../../auth/Auth';
import { getTickets } from '../../actions/Tickets';
import MenuBox from '../../components/MenuBox';
import NotifyPopupShop from '../../components/molecules/NotifyPopupShop';

const Accordion = withStyles({
  root: {
    border: 0,
    boxShadow: 'none',
    '&::before': {
      display: 'none'
    },
    '&$expanded': {
      margin: 'auto'
    }
  },
  expanded: {}
})(MuiAccordion);

const AccordionSummary = withStyles({
  root: {
    backgroundColor: 'rgba(0, 0, 0, .03)',
    borderBottom: '1px solid rgba(0, 0, 0, .125)',
    marginBottom: -1,
    '&$expanded': {
      minHeight: 48
    }
  },
  content: {
    '&$expanded': {
      margin: '12px 0'
    }
  },
  expanded: {}
})(MuiAccordionSummary);

const AccordionDetails = withStyles({
  root: {
    padding: 0,
    display: 'block'
  }
})(MuiAccordionDetails);

const styles = theme => ({
  root: {
    backgroundColor: '#F7F7F7',
    flexGrow: 1,
    width: '100%',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    [theme.breakpoints.up('sm')]: {
      maxWidth: 375,
      backgroundColor: '#F7F7F7',
      margin: '0 auto'
    }
  },
  mainContent: {
    padding: 15
  },
  pageTitileDiv: {
    textAlign: 'left',
    marginBottom: 10
  },
  mainPaper: {
    position: 'relative'
  },
  zoom: {
    position: 'relative',
    left: -10,
    top: 20
  },
  mainPaperTitleDiv: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '20px 26px 10px 26px'
  },
  searchForm: {
    padding: '10px 20px 20px 20px'
  },
  textField: {
    padding: '0px 5px 0px 5px',
    width: '100%',
    marginTop: 0
  },
  textField150: {
    padding: '0px 5px 0px 5px',
    width: '200px'
  },
  button: {
    margin: '5px 5px'
  },
  buttonLeft: {
    textAlign: 'left',
    float: 'left'
  },
  buttonRight: {
    textAlign: 'right'
  },
  fs24: {
    fontSize: '24px'
  },
  fs20: {
    fontSize: '20px'
  },
  buttonCenter: {
    padding: '10px',
    textAlign: 'center'
  },
  gochiBox: {
    padding: 12,
    borderTop: '1px solid #DBDBDB'
  },
  gochiHeader: {
    padding: '10px',
    color: '#ffffff',
    fontSize: 12,
    textAlign: 'center',
    backgroundColor: '#717171',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-end',
    position: 'relative',
    marginBottom: 20,
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',

    '&:before': {
      content: '""',
      position: 'absolute',
      left: '50%',
      bottom: '-12px',
      transform: 'translateY(-50%)',
      display: 'inline-block',
      width: 0,
      height: 0,
      borderStyle: 'solid',
      borderWidth: '8px 5px 0 5px',
      borderColor: '#717171 transparent transparent transparent'
    }
  },
  couponNo: {
    margin: '0 20px',
    fontSize: 26,
    fontWeight: 'bold',
    lineHeight: '22px',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif'
  },
  textCompare: {
    display: 'inline-block',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif'
  },
  remainCoupon: {
    backgroundColor: '#FFD0D5',
    color: '#000000',

    '&:before': {
      borderColor: '#FFD0D5 transparent transparent transparent'
    }
  },
  tableInfo: {
    width: '100%'
  },
  tableInfoCellHeader: {
    padding: '2px 10px',
    width: '90px',
    borderBottom: '2px solid #ffffff',
    fontSize: '12px',
    fontWeight: 'bold',
    color: '#000000',
    backgroundColor: '#F7F7F7'
  },
  tableInfoCell: {
    padding: '2px 10px',
    borderBottom: '2px solid transparent',
    fontSize: '12px'
  },

  boxMessage: {
    padding: '8px 10px',
    border: '1px solid #DBDBDB',
    borderRadius: 6,
    fontSize: 12,
    color: '#000000',
    marginTop: 15
  },
  messageTtl: {
    marginBottom: 5,
    display: 'flex',
    width: '100%',
    alignItems: 'center'
  },
  iconReply: {
    fontSize: 18,
    display: 'inline-block',
    marginRight: 5
  },
  boxMessageReply: {
    fontSize: 12,
    paddingLeft: 10,
    marginTop: 10,
    whiteSpace: 'pre-line'
  },
  inputRoot: {
    width: '100%'
  },
  inputMessage: {
    borderColor: '#DBDBDB',
    borderRadius: 0,
    padding: '10px 15px',
    height: 70,
    fontSize: 12
  },
  buttonSend: {
    marginLeft: 'auto',
    height: 22,
    fontSize: 12,
    padding: 0
  },
  messageReplyBox: {
    backgroundColor: '#F7F7F7',
    borderRadius: 6,
    padding: '8px 10px',
    whiteSpace: 'pre-line'
  },
  textRedBig: {
    color: '#F50357'
  },
  textRed: {
    color: '#F1226D'
  },
  textId: {
    fontSize: 10,
    color: '#777777',
    display: 'inline-block',
    marginLeft: 5
  },
  textCenter: {
    textAlign: 'center',
    marginTop: 15
  },
  searchCollapseBox: {
    marginBottom: '20px'
  },
  collapseBtn: {
    minHeight: 'unset !impotant',
    margin: '0',
    padding: 0
  },

  extendClasses: {
    margin: 0
  }
});

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account,
      ticketsAll: state.tickets.list
    }),
    dispatch => ({
      actions: bindActionCreators({ getTickets }, dispatch)
    })
  ),
  setPropTypes(propTypes),
  withState('openModal', 'updateOpenModal', false),
  withState('openDrawer', 'updateOpenDrawer', false),
  withState('openTable', 'updateOpenTable', false),
  withState('openProgress', 'updateOpenProgress', false),
  withState('loading', 'updateLoading', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('menuId', 'setMenuId', ''),
  withState('menuName', 'setMenuName', ''),
  withState('userName', 'setUserName', ''),
  withState('gochiDateFrom', 'setGochiDateFrom', () => {
    moment.tz.setDefault('Asia/Tokyo');
    return moment()
      .date(1)
      .format('YYYY-MM-DD');
  }),
  withState('gochiDateTo', 'setGochiDateTo', () => {
    return moment()
      .endOf('month')
      .format('YYYY-MM-DD');
  }),
  withState('ticketUseDateFrom', 'setTicketUseDateFrom', ''),
  withState('ticketUseDateTo', 'setTicketUseDateTo', ''),
  withState('gochiUseDateEnableFlg', 'setGochiUseDateEnableFlg', true),
  withState('listTicket', 'setListTicket', []),
  withState('hasMore', 'setHasMore', false),
  withState('messageReply', 'setMessageReply', []),
  withState('shopReplyText', 'setShopReplyText', ''),
  withState('childKey', 'setChildKey', 0),
  withState('openNotifyPopup', 'setOpenNotifyPopup', false),
  withState('textTitle', 'setTextTitle', ''),
  withState('textMessage', 'setTextMessage', ''),
  withState('expandedCollapse', 'setExpandedCollapse', false),
  withState('perPage', 'setPerPage', 10),
  withState('page', 'setPage', 1),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleRedirect: props => path => {
      props.history.push(path);
    },

    loadTicketData: props => page => {
      setTimeout(() => {
        props.updateLoading(true);
        props.updateOpenProgress(true);
        const searchKey = {
          menuName: props.menuName,
          menuId: props.menuId,
          ticketUseDateFrom: props.ticketUseDateFrom,
          ticketUseDateTo: props.ticketUseDateTo,
          limit: 10,
          page
        };
        let list = [];
        if (page > 1) {
          list = props.listTicket;
        } else {
          list = [];
        }

        props.actions
          .getTickets(searchKey)
          .then(data => {
            if (data.error === true && data.payload.status === 403) {
              sendLogin(props);
            }
            props.updateOpenProgress(false);
            props.updateLoading(false);

            if (data.type === 'GET_TICKETS_SUCCESS') {
              console.log('Ticket data ==========', data);
              if (data.payload.list) {
                for (let i = 0; i < data.payload.list.length; i += 1) {
                  if (i < props.perPage) {
                    list.push(data.payload.list[i]);
                  }
                }
                props.setListTicket(list);
                if (data.payload.offset + 10 < data.payload.count) {
                  props.setHasMore(true);
                } else {
                  props.setHasMore(false);
                }
              }
            } else {
              props.setHasMore(false);
            }
          })
          .catch(error => {
            props.updateOpenProgress(false);
            props.setResultMessage('');
            props.updateLoading(false);
            console.log('error', error);
            props.setHasMore(false);
          });
      }, 100);
    }
  }),
  lifecycle({
    async componentDidMount() {
      this.props.setChildKey(this.props.childKey + 1);
      isAuthenticated(this.props);

      this.props.loadTicketData(this.props.page, true);
    },
    componentUnmount() {
      const list = [{ foo: undefined }];
      this.props.setListTicket(list);
      console.log(this.props.listTicket);
    }
  })
);

const Main = enhance(
  ({
    classes, // checkSession, // actions,
    account,
    updateOpenDrawer,
    loading,
    // updateLoading,
    openProgress,
    updateOpenProgress,
    resultMessage,
    // setResultMessage,
    menuName,
    setMenuName,
    ticketUseDateFrom,
    setTicketUseDateFrom,
    ticketUseDateTo,
    setTicketUseDateTo,
    gochiUseDateEnableFlg,
    handleRedirect,
    hasMore,
    loadTicketData,
    listTicket,
    childKey,
    setListTicket,
    menuId,
    setMenuId,
    page,
    setPage,
    textTitle,
    textMessage,
    openNotifyPopup,
    setOpenNotifyPopup,
    expandedCollapse,
    setExpandedCollapse
  }) => {
    // openDrawer, // setGochiUseDateEnableFlg,
    const isShop = typeof account !== 'undefined' && account.role === 'SHOP';

    let searchKey = {
      menuName,
      ticketUseDateFrom,
      ticketUseDateTo,
      menuId,
      limit: 10,
      page
    };

    const isReleased =
      account && account.accountStatus && account.accountStatus.status === true;

    // check if is account shop
    if (!(isShop && isReleased)) {
      handleRedirect('/shops');
    }

    const searchAction = () => {
      setPage(1);
      setExpandedCollapse(false);
      setListTicket([]);

      searchKey = {
        ...searchKey
      };
      loadTicketData(1);
    };

    const loadMoreTickets = () => {
      const newPage = page + 1;
      searchKey = {
        ...searchKey
      };
      loadTicketData(newPage);
      setPage(page + 1);
    };

    const progressOkAction = () => {
      updateOpenProgress(false);
    };

    return (
      <div className={classes.root}>
        <Header
          onMenuClick={() => {
            updateOpenDrawer(true);
          }}
        />

        <div className={classes.mainContent}>
          <div className={classes.pageTitileDiv}>
            <Typography color="textPrimary" className={classes.fs24}>
              社食チケット情報管理
            </Typography>
          </div>
          <div className={classes.searchCollapseBox}>
            <Accordion
              className={classes.boxCollapse}
              expanded={expandedCollapse}
              onChange={() => {
                setExpandedCollapse(!expandedCollapse);
              }}
            >
              <div className={classes.textTitleDiv}>
                <AccordionSummary
                  expandIcon={
                    <ExpandMoreIcon className={classes.arrowCustom} />
                  }
                  aria-controls="statistic-pannel"
                  id="statistic-pannel"
                  className={classes.collapseBtn}
                >
                  <Typography
                    color="textSecondary"
                    className={[classes.fs20, classes.extendClasses]}
                  >
                    チケット検索
                  </Typography>
                </AccordionSummary>
              </div>

              <AccordionDetails>
                <Paper className={classes.mainPaper} elevation={1}>
                  <div className={classes.searchForm}>
                    <div>
                      <TextField
                        label="メニュー名"
                        placeholder="部分一致"
                        type="search"
                        className={classes.textField}
                        margin="normal"
                        value={menuName}
                        onChange={e => {
                          setMenuName(e.target.value);
                        }}
                      />
                      <TextField
                        label="メニューID"
                        placeholder="部分一致"
                        type="search"
                        className={classes.textField}
                        margin="normal"
                        value={menuId}
                        onChange={e => {
                          setMenuId(e.target.value);
                        }}
                      />
                    </div>
                    <div>
                      <TextField
                        label="利用日（From)"
                        type="date"
                        className={classes.textField150}
                        margin="normal"
                        InputLabelProps={{
                          shrink: true
                        }}
                        disabled={!gochiUseDateEnableFlg}
                        value={ticketUseDateFrom}
                        onChange={e => {
                          setTicketUseDateFrom(e.target.value);
                        }}
                      />
                      <TextField
                        label="利用日（To)"
                        type="date"
                        className={classes.textField150}
                        margin="normal"
                        InputLabelProps={{
                          shrink: true
                        }}
                        disabled={!gochiUseDateEnableFlg}
                        value={ticketUseDateTo}
                        onChange={e => {
                          setTicketUseDateTo(e.target.value);
                        }}
                      />
                    </div>
                    <div className={classes.textLeft}>
                      <SearchButton onClickAction={searchAction} />
                    </div>
                  </div>
                </Paper>
              </AccordionDetails>
            </Accordion>
          </div>

          <Paper>
            {/* <div className={classes.buttonCenter}>
              <CsvDownloadButton onClickAction={csvDownloadAction} />
            </div> */}
            <div className={classes.infiniteScroll}>
              {/* <InfiniteScroll
                pageStart={1}
                loadMore={loadTicketData}
                hasMore={hasMore}
                loader={loader}
                initialLoad={false}
                key={childKey}
              > */}
              <div
                className="select-block-body m-0"
                key={`box${childKey}`}
                // style={{ height: '1000px', overflow: 'auto' }}
              >
                <div className="lst-friends h-100" key={`list${childKey}`}>
                  {listTicket &&
                    listTicket.map(ticket => {
                      const key = `${ticket.shashokuTicketId}`;
                      return (
                        <div className={classes.gochiBox} key={key}>
                          <div className={classNames(classes.gochiHeader)}>
                            <b>利用状況</b>
                          </div>

                          <Table>
                            <TableBody className={classes.tableInfo}>
                              <TableRow className={classes.tableInfoRow}>
                                <TableCell
                                  className={classes.tableInfoCellHeader}
                                >
                                  利用日
                                </TableCell>
                                <TableCell className={classes.tableInfoCell}>
                                  {ticket.createdAt}
                                </TableCell>
                              </TableRow>
                              <TableRow>
                                <TableCell
                                  className={classes.tableInfoCellHeader}
                                >
                                  利用した人
                                </TableCell>
                                <TableCell className={classes.tableInfoCell}>
                                  {ticket.userEmail}
                                </TableCell>
                              </TableRow>
                              <TableRow>
                                <TableCell
                                  className={classes.tableInfoCellHeader}
                                >
                                  メニュー名
                                </TableCell>
                                <TableCell className={classes.tableInfoCell}>
                                  {ticket.shashokuMenu.menuName}
                                </TableCell>
                              </TableRow>
                              {/* <TableRow>
                                <TableCell
                                  className={classes.tableInfoCellHeader}
                                >
                                  個数
                                </TableCell>
                                <TableCell className={classes.tableInfoCell}>
                                  {gochi.couponCount}
                                </TableCell>
                              </TableRow> */}
                              <TableRow>
                                <TableCell
                                  className={classes.tableInfoCellHeader}
                                >
                                  税込価格
                                </TableCell>
                                <TableCell className={classes.tableInfoCell}>
                                  {ticket.usedPrice}
                                  {`円`}
                                </TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                        </div>
                      );
                    })}
                </div>
              </div>
              {/* </InfiniteScroll> */}
            </div>
          </Paper>

          {hasMore && (
            <div className={classes.textCenter}>
              <Button
                variant="contained"
                color="primary"
                siz="xs"
                // className={classes.buttonSend}
                onClick={() => {
                  loadMoreTickets();
                }}
              >
                もっと見る
              </Button>
            </div>
          )}
        </div>

        <div>
          <Modal open={openNotifyPopup}>
            <NotifyPopupShop
              setOpenNotifyPopup={setOpenNotifyPopup}
              textTitle={textTitle}
              textMessage={textMessage}
            />
          </Modal>
        </div>

        <ProgressDialog
          openProgress={openProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
        />
        <MenuBox account={account} />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
